import { useAppDispatch, useAppSelector } from 'dux/app/hooks';

import isEmpty from 'lodash/isEmpty';

import {
  getCartItemsWithoutCoupons,
  getHasSkincareMinisInCatalog,
  getHasSkincareMinisInItems,
  getSkincareMinisProductsFromCatalog,
  getSkincareMinisRecommendedSectionFromCatalog,
} from 'dux/checkoutCart/selectors';
import * as thunks from 'dux/checkoutCart/thunks';

export const useSkincareMinisAtCart = () => {
  const dispatch = useAppDispatch();
  const hasSkincareMinisInCatalog = useAppSelector(getHasSkincareMinisInCatalog);
  const hasSkincareMinisInItems = useAppSelector(getHasSkincareMinisInItems);
  const skincareMinisProductsFromCatalog = useAppSelector(getSkincareMinisProductsFromCatalog);
  const currentItemsInCart = useAppSelector(getCartItemsWithoutCoupons);
  const skincareMinisRecommendedSectionFromCatalog = useAppSelector(
    getSkincareMinisRecommendedSectionFromCatalog,
  );

  const formattedItemsPayload = (quantity: number) =>
    skincareMinisProductsFromCatalog.map(({ type, category, subscription }) => ({
      type,
      category,
      quantity,
      subscription: subscription?.subscribable
        ? {
            active: true,
            frequency: subscription?.recommended_frequency ?? 4,
          }
        : null,
    }));

  const onAddSkincareMinis = () => {
    if (!isEmpty(currentItemsInCart)) {
      dispatch(
        // @ts-expect-error
        thunks.updateCart({
          items: [
            ...formattedItemsPayload(1),
            // @ts-expect-error those selectors are not migrated in TS
            ...currentItemsInCart.map(({ type, category, subscription }) => ({
              type,
              category,
              quantity: 0,
              subscription: subscription?.subscribable
                ? {
                    active: true,
                    frequency: subscription?.recommended_frequency ?? 4,
                  }
                : null,
            })),
          ],
        }),
      );
    } else {
      dispatch(
        // @ts-expect-error
        thunks.updateCart({
          items: formattedItemsPayload(1),
        }),
      );
    }
  };

  const onDeleteSkincareMinis = () =>
    dispatch(
      // @ts-expect-error
      thunks.updateCart({
        items: formattedItemsPayload(0),
      }),
    );

  return {
    hasSkincareMinisInItems,
    hasSkincareMinisInCatalog,
    skincareMinisProductsFromCatalog,
    onAddSkincareMinis,
    onDeleteSkincareMinis,
    skincareMinisRecommendedSectionFromCatalog,
  };
};
